// @flow
import React from 'react'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import './styles.scss'
import SunImage from './images/sun.jpg'
import CloudImage from './images/clouds.jpg'
import explainerImage from './images/explainer.jpg'
import explainerImageMobile from './images/explainer-mobile.jpg'

const isMobile = browserCheck.isMobile

export class Day extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {}
  }

  componentDidMount() {}

  render() {
    //console.log('percentage:', this.props.percentage)
    let sunPercentage = parseFloat(this.props.percentage)
    let emHeight = isMobile
      ? (2.4 / 100) * sunPercentage
      : (4 / 100) * sunPercentage

    return (
      <div
        className={this.props.children === '1.' ? 'day first' : 'day'}
        style={{
          backgroundSize: isMobile ? '2.4em' : '4em'
        }}
      >
        {this.props.percentage < 0 && (
          <div
            className='cloud-image'
            style={{
              background: `url(${
                isMobile ? explainerImageMobile : explainerImage
              })`,
              backgroundSize: isMobile ? '2.4em' : '4em',
              backgroundRepeat: 'no-repeat'
            }}
          />
        )}
        {this.props.percentage > 0 && (
          <React.Fragment>
            <div
              className='cloud-image'
              style={{
                background: `url(${CloudImage})`,
                backgroundSize: isMobile ? '2.4em' : '4em',
                backgroundRepeat: 'no-repeat'
              }}
            />
            <div
              className='sun-image'
              style={{
                background: `url(${SunImage})`,
                backgroundSize: isMobile ? '2.4em' : '4em',
                backgroundRepeat: 'no-repeat',
                height: emHeight + 'em'
              }}
            />
            <div className='date-txt'>
              {
                this.props
                  .children /* this.props.children + ' | ' + this.props.percentage */
              }
            </div>
            {this.props.children === '1.' && (
              <div className='month-txt'>
                {
                  this.props
                    .month /* this.props.children + ' | ' + this.props.percentage */
                }
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    )
  }
}
